export default {
  init() {
    // JavaScript to be fired on the home page
    // // When the user scrolls the page, execute myFunction
    window.onscroll = function() {
      scrollFunction()
    };

    // Get the header
    var header = document.getElementById('primary');
    console.log(header);

    // Get the offset position of the navbar
    var sticky = header.offsetTop;
    setTimeout(function() {
      sticky = header.offsetTop;
    }, 500);

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function scrollFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add('fixed-top');
      } else {
        header.classList.remove('fixed-top');
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js